import { type RouteRecordRaw } from 'vue-router'

const purchaseOrdersRoutes: Array<RouteRecordRaw> = [
  {
    path: '/purchasing/purchase-orders',
    name: 'purchase-orders.index',
    component: () => import('@/modules/purchasing/purchase-orders/views/PurchaseOrdersIndex.vue'),
    meta: {
      pageTitle: 'Purchase Orders',
      breadcrumbs: ['Purchase orders']
    }
  },
  {
    path: '/purchasing/purchase-orders/:id',
    name: 'purchase-orders.show',
    component: () => import('@/modules/purchasing/purchase-orders/views/PurchaseOrdersShow.vue'),
    meta: {
      pageTitle: 'Purchase Orders',
      breadcrumbs: ['Purchase orders']
    }
  },
  {
    path: '/purchasing/purchase-orders/create',
    name: 'purchase-orders.create',
    component: () => import('@/modules/purchasing/purchase-orders/views/PurchaseOrderCreate.vue'),
    meta: {
      pageTitle: 'Create Purchase Order',
      breadcrumbs: ['Purchase orders', 'Create']
    }
  },
  {
    path: '/purchasing/summary',
    name: 'purchasing.summary',
    component: () => import('@/modules/purchasing/purchase-orders/views/PurchaseOrdersSummary.vue'),
    meta: {
      pageTitle: 'Purchase Orders Summary',
      breadcrumbs: ['Purchase orders']
    }
  }
]

export default purchaseOrdersRoutes
